module.exports = __webpack_public_path__ + "img/location.8748d720.svg";